import React from 'react';
import theme from '../../../../../../../../styles/theme';
import Color from './components/Color';
import Frame from './components/Frame';
import Text from './components/Text';
import Wrapper from './components/Wrapper';

function Subtitle() {
  return (
    <Frame.Base>
      <Wrapper.ColorAndLabel>
        <Color color="#fff" bordercolor="#888" />
        <Text>Contas Aprovadas | Contas Ativas</Text>
      </Wrapper.ColorAndLabel>
      <Wrapper.ColorAndLabel>
        <Color
          color={theme.colors.desactivated}
          bordercolor={theme.colors.desactivated}
        />
        <Text>Conta Encerrada</Text>
      </Wrapper.ColorAndLabel>
      <Wrapper.ColorAndLabel>
        <Color
          color={theme.colors.pending}
          bordercolor={theme.colors.pending}
        />
        <Text>Conta Pendente</Text>
      </Wrapper.ColorAndLabel>
      <Wrapper.ColorAndLabel>
        <Color
          color={theme.colors.rejected}
          bordercolor={theme.colors.rejected}
        />
        <Text>Conta Rejeitada</Text>
      </Wrapper.ColorAndLabel>
      <Wrapper.ColorAndLabel>
        <Color
          color={theme.colors.blocked}
          bordercolor={theme.colors.blocked}
        />
        <Text>Conta Bloqueada</Text>
      </Wrapper.ColorAndLabel>
    </Frame.Base>
  );
}

export default Subtitle;
